import React, { useEffect, useState } from 'react';
import {
  Box,
  VStack,
  HStack,
  Text,
  Button,
  Divider,
  useColorModeValue,
} from '@chakra-ui/react';
import {
  AddToCalendarIcon,
  AlertIconCalendar,
  ConflictCalendarIcon,
  GoogleCircleIcons,
  ICloudIcon,
  OutLookCircle,
  CalendarIconRightArrow
} from '@mybridge/icons';
import { ExchangeLogo } from '@mybridge/icons/ExchangeLogo';
import CheckConflictsModal from './CheckConflicts';
import AddCalendarSelectionModal from './AddCalendarSelectionModal';
import { useSelector } from 'react-redux';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
// import { AlertIcon } from '@mybridge/ui';

// Placeholder icons for different calendar types
const calendarIcons = {
  google: <GoogleCircleIcons />,
  microsoft: <OutLookCircle width="30" height="30" />,
  Exchange: <ExchangeLogo width="30" height="30" />,
  iCloud: <ICloudIcon />,
  noneSelected: <AlertIconCalendar />,
};

// Dynamic Card Component
const CalendarCard = ({ item, title,handleGetCalendarList,handleUpdateCalendar,fromNoCalendar=false }) => {
  const isDisabled = !item.isConnected;
  const { t } = useTranslator();
  const [isConflictModalOpen, SetIsConflictModalOpen] = useState(false);
  const [isAddCalendarModalOpen, setIsAddCalendarModalOpen] = useState(false);


  return (
    <>
      {(!item || (Array.isArray(item) && item.length === 0))&& (
          <HStack
            border={'1px solid #D9D9D9'}
            borderRadius="16px"
            p={'16px'}
            w="100%"
            align={'start'}
            justify="space-between"
          >
            <HStack spacing={3} align={'start'}>
              <Box>{calendarIcons.noneSelected}</Box>
              <VStack align="flex-start" spacing={0} maxW={250}>
                <Text
                  fontSize="16px"
                  fontWeight="500"
                  color="#5B5B5B"
                  lineHeight={'21.76px'}
                >
                  {t('settingsIntegration.calendarNotSelected') || "Calendar not selected"}
                </Text>
                <Text fontSize="17px" color="#747474" lineHeight={'23.8px'}>
                  {t('settingsIntegration.doNotAddEvents') || "Do not add new events to any calendar"}
                </Text>

                <Box mt={2} borderTop={'1px solid #D9D9D9'}>
                  <Text
                    mt={2}
                    fontSize="13px"
                    color="#3D5A80"
                    lineHeight={'23.8px'}
                  >
                    {t('settingsIntegration.noCalendarSelected') || "There is no calendar selected to add events to. Events created will not be automatically added to your calendar."}
                  </Text>
                </Box>
              </VStack>
            </HStack>

            {/* <HStack spacing={3} align={'start'}> */}

            {/* </HStack> */}
            <Button
              size="sm"
              variant="link"
              _hover={{ textDecorationLine: 'none' }}
              color="#3D5A80"
              fontWeight={500}
              fontSize="16px"
              lineHeight="21.76px"
              onClick={() => {
                title === t('settingsIntegration.checkForConflicts') || 'Check for conflicts'
                  ? SetIsConflictModalOpen(true)
                  : setIsAddCalendarModalOpen(true);
              }}
            >
              {t('buttons.edit') || "Edit"}
            </Button>
          </HStack>
        )}

      {!!item?.length>0||!!item.calendarType && (
        <HStack
          border={'1px solid #D9D9D9'}
          //borderRadius="md"
          boxShadow="md"
          borderRadius="20px"
          p={'16px'}
          w="100%"
          align={'start'}
          opacity={isDisabled ? 0.5 : 1}
          cursor={isDisabled ? 'not-allowed' : 'pointer'}
          justify="space-between"
        >
          <HStack spacing={3} align={'start'}>
            <Box>{calendarIcons[item.calendarType]}</Box>
            <VStack align="flex-start" spacing={0} maxW={203}>
              <Text
                fontSize="16px"
                fontWeight="500"
                color="#5B5B5B"
                lineHeight={'21.76px'}
              >
                {item.name}
              </Text>
              <Text fontSize="17px" color="#747474" lineHeight={'23.8px'}>
                {t('settingsIntegration.usePlugin') || "Use the plug-in to select specific calendars."}
              </Text>
            </VStack>
          </HStack>
          <Button
            size="sm"
            variant="link"
            _hover={{ textDecorationLine: 'none' }}
            color="#3D5A80"
            isDisabled={isDisabled}
            fontWeight={500}
            fontSize="16px"
            lineHeight="21.76px"
            onClick={() => {
              title === t('settingsIntegration.checkForConflicts') || 'Check for conflicts'
                ? SetIsConflictModalOpen(true)
                : setIsAddCalendarModalOpen(true);
            }}
          >
            {t('buttons.edit') || "Edit"}
          </Button>
        </HStack>
      )}

      {isConflictModalOpen && (
        <CheckConflictsModal
          isOpen={isConflictModalOpen}
          selectedCalendar={item}
          calendarIcons={calendarIcons}
          onClose={() => SetIsConflictModalOpen(false)}
        />
      )}

      {isAddCalendarModalOpen && (
        <AddCalendarSelectionModal
        fromNoCalendar={fromNoCalendar}
        handleUpdateCalendar={handleUpdateCalendar}
          isOpen={isAddCalendarModalOpen}
          onUpdate={item.onUpdate}
          onClose={() => setIsAddCalendarModalOpen(false)}
          calendars={item}
          handleGetCalendarList={handleGetCalendarList}
        />
      )}
    </>
  );
};

// Section Component
const Section = ({ title, description, items, icon,handleGetCalendarList,handleUpdateCalendar }) => {


  return (
    <>
      <HStack align="flex-start" spacing={4} w="100%">
        <HStack align="flex-start" gap={4}>
          {icon}
          <VStack align="flex-start" spacing={2} mt={1}>
            <Text
              fontSize="18px"
              color="#5B5B5B"
              fontWeight="500"
              lineHeight={'24.48px'}
            >
              {title}
            </Text>
            <Text fontSize="15px" color="#747474" lineHeight={'24.2px'} width='70%'>
              {description}
            </Text>
          </VStack>
        </HStack>
        <VStack w="100%" spacing={4}>
          {!items ||
            (items?.length === 0 && (
              <CalendarCard fromNoCalendar={true} handleUpdateCalendar={handleUpdateCalendar} handleGetCalendarList={handleGetCalendarList} key={0} item={[]} title={''} />
            ))}

          {items?.map((item, index) => (
            <CalendarCard handleGetCalendarList={handleGetCalendarList} key={index} item={item} title={title} />
          ))}
        </VStack>
      </HStack>
    </>
  );
};

// Main Component
const CalendarConfiguration = ({ calendars,handleGetCalendarList }) => {
  const { t } = useTranslator();
  const { calendarList } = useSelector((state) => state.settings);
  const getInitialSelectedCalendar = () => {
    return (
      calendarList?.find((calendar) => calendar?.selected)?.provider || 'none'
    );
  };
  const [selectedAddCalendar, setSelectedAddCalendar] = useState(
    getInitialSelectedCalendar()
  );

  const handleUpdateCalendar = (newCalendar) => {
    setSelectedAddCalendar(newCalendar);
  };


  // Use the original calendar title to match with icon keys
  const conflictCalendars = calendars?.map((calendar) => {
    const calendarType = calendar?.title?.split(' ')?.[0]?.trim();
    return {
      name: `${t('settingsIntegration.checkFor') || "Check for"} ${calendarType} ${t('settingsIntegration.pluginWindows') || "plug-in (Windows)"}`,
      calendarType, // Pass the extracted calendar type
      isConnected: calendar?.isConnected,
    };
  });

  // Use the initial selected calendar for the state

  const addCalendars = calendars
    ?.filter((calendar) => calendar?.key?.includes(selectedAddCalendar))
    ?.map((calendar) => ({
      name: `${t('settingsIntegration.addTo') || "Add to"} ${calendar?.title} ${t('settingsIntegration.pluginWindows') || "plug-in (Windows)"}`,
      calendarType: selectedAddCalendar,
      isConnected: calendar?.isConnected, // Dynamically set based on actual connection
      onUpdate: handleUpdateCalendar, // Pass the update handler
    }));


  useEffect(() => {
    setSelectedAddCalendar(getInitialSelectedCalendar());
  }, [calendarList]);
  return (
    <VStack align="flex-start" pt={2} w="100%" gap="36px" fontFamily="Inter">
      {/* <Section
        title="Check for conflicts"
        description="Set the calendar(s) to check for conflicts to prevent double bookings."
        items={conflictCalendars}
        icon={<ConflictCalendarIcon />}
      />
      <Divider /> */}
      <Section
        title={t('settingsIntegration.addToCalendar') || "Add to calendar"}
        description={t('settingsIntegration.setCalendarAdd') || "Set the calendar you like to add new events to as they're scheduled."}
        items={addCalendars}
        icon={<AddToCalendarIcon />}
        handleGetCalendarList={handleGetCalendarList}
        handleUpdateCalendar={handleUpdateCalendar}
      />
    </VStack>
  );
};

export default CalendarConfiguration;